var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Publishing")]),
      _c("status-radio", {
        model: {
          value: _vm.distribution.status,
          callback: function($$v) {
            _vm.$set(_vm.distribution, "status", $$v)
          },
          expression: "distribution.status"
        }
      }),
      _c("date-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.distribution.status !== "draft" ? true : false,
            expression: "distribution.status !== 'draft' ? true : false"
          }
        ],
        ref: "availableFrom",
        attrs: {
          validation: _vm.validations.startDate,
          formSubmitted: _vm.formSubmitted,
          label: "Available from"
        },
        model: {
          value: _vm.distribution.startDate,
          callback: function($$v) {
            _vm.$set(_vm.distribution, "startDate", $$v)
          },
          expression: "distribution.startDate"
        }
      }),
      _c("date-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.distribution.status !== "draft" ? true : false,
            expression: "distribution.status !== 'draft' ? true : false"
          }
        ],
        ref: "availableUntil",
        style: _vm.dateValid ? null : { color: "#f44336" },
        attrs: {
          validation: _vm.validations.endDate,
          formSubmitted: _vm.formSubmitted,
          label: "Available until"
        },
        model: {
          value: _vm.distribution.endDate,
          callback: function($$v) {
            _vm.$set(_vm.distribution, "endDate", $$v)
          },
          expression: "distribution.endDate"
        }
      }),
      !_vm.dateValid && _vm.distribution.status !== "draft"
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v(
              'The date of "available until" cannot be a day before today or before the date of "available from".'
            )
          ])
        : _vm._e(),
      _c("rental-pricing-form", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.distribution.status !== "draft" ? true : false,
            expression: "distribution.status !== 'draft' ? true : false"
          }
        ],
        attrs: {
          price:
            _vm.distribution.prices &&
            _vm.distribution.prices.length > 0 &&
            _vm.distribution.prices[0].price
              ? _vm.distribution.prices[0].price.amount
              : null
        },
        on: { "price-selected": _vm.handlePriceSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-317d8898", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-317d8898","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/form-components/PublishingForm.vue
// module id = 786
// module chunks = 0